<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <h1>Uw WPBR-Passen</h1>
            </div>
            <div class="col-md-6 text-md-right text-center">
                <router-link tag="button" class="btn btn-lg btn-outline-azure-dark mb-3" :to="{ name: 'ProfessionalProfilePassRequest'}">
                    <font-awesome-icon icon="plus" class="mr-2"></font-awesome-icon> Pas Aanvragen
                </router-link>
            </div>
        </div>
        <pass-manager :passes="passes" :save="true" @add-pass="add" :removeable="false"></pass-manager>
    </div>
</template>

<script>
import PassManager from '@/components/PassManager'
export default {
    components: {
        PassManager
    },
    data() {
        return {
            passes: []
        }
    },
    mounted() {
        this.get();
    },
    methods: {
        get() {
            this.$http.get('api/Pass').then((res) => {
                this.passes = res.data.map((p) => {
                    return {
                        name: p.thumbnail.fileName,
                        document: p.thumbnail,
                        documentId: p.documentId,
                        color: p.thumbnail.fileName.split("_")[0],
                        permitNumber: p.permitNumber,
                        passNumber: p.passNumber,
                        validTo: p.validTo
                    }
                });
            });
        },
        add(pass)
        {
            this.passes.push(pass);
        }
    }
}
</script>